import type React from "react";
import { Box, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { tokens } from "../../theme";
import type { RootState } from "../../store/Index";

interface StagingTagProps {
  isStaging: boolean;
  borderColor: string;
  badgeColor: string;
  badgeText: string;
}

export const StagingTag: React.FC<StagingTagProps> = ({
  isStaging,
  borderColor,
  badgeColor,
  badgeText,
}) => {
  const theme = useTheme();
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const colors = tokens(theme.palette.mode, reduxTheme);

  if (!isStaging) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: -36,
        transform: "translateY(-50%) rotate(-90deg)",
        bgcolor: badgeColor,
        color: colors.primary[700],
        px: 2,
        py: 1,
        fontWeight: 900,
        fontSize: "0.8rem",
        letterSpacing: "2px",
        textTransform: "uppercase",
        borderRadius: "0 0 8px 8px",
        boxShadow: "0 4px 12px rgba(251, 191, 36, 0.5)",
        zIndex: 10,
        whiteSpace: "nowrap",
        border: `2px solid ${borderColor}`,
      }}
    >
      {badgeText}
    </Box>
  );
};
